import React, { useState, useEffect, lazy, Suspense } from "react";
import { TabItem, TabControl } from "@abb/abb-common-ux-react";
import AllDevice from "../../../pages/cybershield/alldevices";
import "./cybershield.css";
import { RootProvider } from "../../../contexts/root-context";
import { getDefaultTimeStamp } from "./../../../util";
import configData from "./cybershield-navbar.json"
import { getToken } from "../../../components/Authentication/get-token";
import {CYBERSHIELD_BASE_API_URL} from "../../../strings";
import { isCybershieldModuleVisible, getUIConfig } from "../../../utils/uiConfigUtils";

// Lazy load Cybershield modules
const Posture = lazy(() => import("../../../pages/cybershield/Posture/Posture"));

const Rim = () => null;
function CybershieldNavBar() {
  // const [deviceData, setDeviceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [configLoaded, setConfigLoaded] = useState(false);
 
  const [PlantIdData, setPlantIdData] = useState([])

  const [activeTab, setActiveTab] = React.useState(0);

  
   const [ showConfigureSBOMPage, setShowConfigureSBOMPage ] = useState(false);

  const [rimData, setrimData] = useState([]);
  const [rimLaodingData, setrimLaodingData] = useState(true);
  const [selectedSubstation, setSelectedSubstation] = useState('');
  const [selectedDevice, setSelectedDevice] = useState('');

  let defaultTS = getDefaultTimeStamp();
  const [startTS, setstartTS] = React.useState(defaultTS.startDate);
  const [endTS, setendTS] = React.useState(defaultTS.endDate);

  // Load UI configuration from DynamoDB on mount
  useEffect(() => {
    const loadConfig = async () => {
      try {
        console.log('🔄 Cybershield: Loading UI Configuration from DynamoDB...');
        await getUIConfig(); // This fetches from DynamoDB and caches in localStorage
        setConfigLoaded(true);
        console.log('✅ Cybershield: Configuration loaded');
      } catch (error) {
        console.error('❌ Cybershield: Error loading configuration:', error);
        setConfigLoaded(true); // Continue with cached config
      }
    };
    loadConfig();
  }, []);


 const deviceData = {
    message: "Successfully fetched 5 records for PlantId = LAB1",
    data: [
      {
        DeviceName: "Zenon_Main_Server",
        Infrastructure: "CDEC",
        LastUpdated: "2025-06-19T07:59:00.317428",
        IPAddress: "192.168.1.54",
        Status: "Disconnected",
        ID: "001",
        PlantId: "LAB1"
      },
      {
        DeviceName: "Open_PLC",
        Infrastructure: "CDEC",
        LastUpdated: "2025-06-19T07:59:00.555540",
        IPAddress: "192.168.1.27",
        Status: "Disconnected",
        ID: "003",
        PlantId: "LAB1"
      },
      {
        DeviceName: "EL_Gateway",
        Infrastructure: "CDEC",
        LastUpdated: "2025-06-19T07:59:00.534363",
        IPAddress: "192.168.1.96",
        Status: "Disconnected",
        ID: "002",
        PlantId: "LAB1"
      },
      {
        DeviceName: "REX615_1",
        Infrastructure: "CDEC",
        LastUpdated: "2025-06-19T07:59:00.575537",
        IPAddress: "192.168.1.67",
        Status: "Connected",
        ID: "004",
        PlantId: "LAB1"
      },
      {
        DeviceName: "REX615_2",
        Infrastructure: "CDEC",
        LastUpdated: "2025-06-19T07:59:00.615587",
        IPAddress: "192.168.1.44",
        Status: "Connected",
        ID: "005",
        PlantId: "LAB1"
      }
    ]
  };

  
    const getAuthHeaders = () => {
        const tokenObj = getToken();
        return {
            "Content-Type": "application/json",
            ...(tokenObj?.headers || {}),
        };
    };

  // const fetchrimData = async () => {
  //   setrimLaodingData(true);
  //   try {
  //     // const response = await fetch(
  //     //  cybershieldRIM_BASE_API_URL
  //     // );
  //     const response = await fetch(cybershieldRIM_BASE_API_URL, {
  //     method: "GET",
  //     headers: getAuthHeaders(),
  //   });

  //    console.log("rim data////",response.data)
  //     if (!response.ok)
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     const data = await response.json();
  //      console.log("kkk.....",response.data)
  //     setrimData(data);

  //   } catch (err) {
  //     console.error("Failed to fetch login data:", err);
  //     setrimData([]); // Clear data on error
  //   } finally {
  //     setrimLaodingData(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchrimData();
  // }, [startTS, endTS]);

  
const fetchrimData = async () => {
  setrimLaodingData(true);
  try {
    const response = await fetch(
       `${CYBERSHIELD_BASE_API_URL}/RIMFetchData?plantId=LAB1&startDateTime=2025-01-30T00:00:00&endDateTime=2025-01-30T23:59:59`,
      {
      method: "GET",
      headers: getAuthHeaders(),
    });

    if (!response.ok)
      throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    console.log("rim data", data);  // ✅ Correct console log
    setrimData(data);
  } catch (err) {
    console.error("Failed to fetch login data:", err);
    setrimData([]); // Clear data on error
  } finally {
    setrimLaodingData(false);
  }
};

useEffect(() => {
  fetchrimData();
}, [startTS, endTS]);

  const handleTabChange = (oldIndex, newIndex) => {
    setActiveTab(newIndex);
  };

  // const fetchData = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //      cybershieldPosture_BASE_API_URL
  //     );

      
  //     if (!response.ok)
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     const Data = await response.json();
  //     console.log("deviceAPIData", Data)
  //     setDeviceData(Data);

  //   } catch (err) {
  //     console.error("Failed to fetch login data:", err);
  //     setDeviceData([]); // Clear data on error
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);


  const fetchByPlantId = async () => {
    
    setLoading(true);
    try {
      // const response = await fetch(
      //  cybershieldPlantId_Base_API_URL
      // );
      
        const response = await fetch(
           `${CYBERSHIELD_BASE_API_URL}/SbomScanner-ScanTrigger?plantId=Lab1`,
          
          {
      method: "GET",
      headers: getAuthHeaders(),
    });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const Data = await response.json();
      const data = Data.data;
      console.log("APIData", data)
     setPlantIdData(data);

    } catch (err) {
      console.error("Failed to fetch login data:", err);
      setPlantIdData([]); // Clear data on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchByPlantId();
  }, []);



// Dynamically map components with Suspense for lazy-loaded modules
  const componentMap = {
    Posture: (
      <Suspense fallback={<div className="lazy-loader">Loading Posture...</div>}>
        <Posture />
      </Suspense>
    ),
    Rim: (
      <Suspense fallback={<div className="lazy-loader">Loading RIM...</div>}>
        <Rim />
      </Suspense>
    ),
    AllDevice: <AllDevice />
  };

  // Check if at least one Cybershield module is visible
  const isPostureVisible = isCybershieldModuleVisible('posture');
  const isRimVisible = false;
  const anyCybershieldModuleVisible = isPostureVisible || isRimVisible;

  // Build tabs dynamically from config with UI configuration filtering
  const tabs = configData.tabs
    .filter(tab => {
      // Check if component exists and backend config is enabled
      if (!componentMap[tab.component] || !configData[tab.component]?.isEnabled) {
        return false;
      }
      
      // Check UI configuration for Posture and RIM
      if (tab.component === "Posture") {
        return isPostureVisible;
      }
      if (tab.component === "Rim") {
        return isRimVisible;
      }
      
      // AllDevice tab should only show if at least one module is visible
      if (tab.component === "AllDevice") {
        return anyCybershieldModuleVisible;
      }
      
      return true;
    })
    .map(tab => ({
      key: tab.key,
      title: tab.title,
      content: componentMap[tab.component]
    }));

  // If no tabs are visible, don't render the component
  if (!configLoaded) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Loading configuration...</div>;
  }

  if (tabs.length === 0) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', fontSize: '16px', color: '#666' }}>
        <p>No Cybershield modules are currently enabled.</p>
        <p>Please go to Admin Panel → Edit Modules and enable Cybershield modules, then save the UI Configuration.</p>
      </div>
    );
  }

  return (
    <div style={{ margin: "1rem 0", width: "100%" }}>
      < RootProvider value={{ rimData, rimLaodingData, setstartTS, startTS, setendTS, endTS, selectedSubstation, setSelectedSubstation, selectedDevice, setSelectedDevice, deviceData, loading, setLoading, setPlantIdData,PlantIdData ,showConfigureSBOMPage,
            setShowConfigureSBOMPage,}}>


        <TabControl
          type="primary"
          activeTab={activeTab}
          onTabChange={handleTabChange}
        >
           {tabs.map(tab => (
            <TabItem key={tab.key} title={tab.title}>
              {tab.content}
            </TabItem>
          ))}
        </TabControl>


      </ RootProvider>
    </div>
  );
}

export default CybershieldNavBar;
